import ExtensionUpsellTile from 'containers/user/critical-elements-monitoring/components/extension-upsell-tile';
import { getExtensionDisplayLabel } from 'containers/user/critical-elements-monitoring/monitoring-constants';
import type { StageCardDisplayMode } from 'containers/user/critical-elements-monitoring/components/funnel-stage-card';
import type { ExtendWithOption } from 'containers/user/critical-elements-monitoring/critical-elements-monitoring.types';

export interface ExtensionUpsellCardProps {
  type: ExtendWithOption;
  displayMode: StageCardDisplayMode;
}

const ExtensionUpsellCard = ({
  type,
  displayMode,
}: ExtensionUpsellCardProps) => (
  <ExtensionUpsellTile
    title={getExtensionDisplayLabel(type, displayMode)}
    type={type}
    contactTestId={`extension-upsell-contact-${type}`}
    testId={`extension-upsell-${type}`}
  />
);

export default ExtensionUpsellCard;
